import styled from 'styled-components'

export const Container = styled.div`

  background-color: #222;
  padding: 2rem 0 1rem 0;
  color: #fff;
  position: relative;
  width: 100%; 

  a {
    text-decoration: none;
    color: #fff;

    font-family: Poppins;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 26px;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  .footer{
    margin: auto;
    width: 80%;
    background-color: #222;
  }

  .footer-top{
    display: flex;
    justify-content: center;
    padding-bottom: 2rem;
    flex-wrap: wrap;

    @media (max-width: 1100px){
      .footer-heading{
        margin-top: 3rem;
      }
    }
  }

  .footer-bottom{
    margin-top: 1rem;
    border: 1px;
    border-style: solid hidden hidden hidden;
    border-color: #fff;
    padding-top: 2rem;
    text-align: center;
    p{
      font-family: Poppins;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: rgba(248, 248, 255)
    }
  }

  .footer-heading{
    display: flex;
    flex-direction: column;
    min-width: 100px;
    margin: 0 2rem;
  }

  .footer-heading h2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;

    margin-bottom: 0.75rem;
  }


  .footer-logo{
    width: 20%;
    @media (max-width: 1100px){
      margin: 0 auto;
      width: 100%;
      p{
        width: 70%;
      }
    }
    margin: 0 3rem;
    p{
      margin: 0 auto;
      text-align:center;
      font-family: Poppins;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
    }
    .footer-social, p{
      margin-top: 1rem;
    }
  }

  .logo {
      width: 140px;
      margin: auto;
      a{
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: 4rem;
        img {
          
            height: 3rem;
        }
    }
  }

  .footer-social{
    width: 120px;
    margin: auto;
    *{
      margin: 0 0.25rem;
    }
  }


`